import { BatteryScenario } from "@/features/BatteryOutlook/types";
import { Alert, Stack, Text } from "@origin-digital/ods-core";
import { formatLabel } from "@/utils";
import React from "react";
import { batterySupported as batterySupportedContent } from "../content.json";

export const OutcomeAlert = ({
  batteryScenario,
  state,
}: {
  batteryScenario: BatteryScenario;
  state: string;
}) => {
  const scenarioContent = batterySupportedContent[batteryScenario];

  const outcomeAlertTone =
    batteryScenario === BatteryScenario.MAY_SUPPORT_BATTERY
      ? "caution"
      : "positive";

  return (
    <Alert tone={outcomeAlertTone}>
      <Stack space={"xsmall"}>
        <Text tone={"neutralDark"} variant={"body-small"}>
          {formatLabel(
            scenarioContent.alert.generationInYourStateText,
            (value) => (
              <>{value}</>
            ),
            state!
          )}
        </Text>
        <Text tone={"neutralDark"} variant={"body-small"}>
          {scenarioContent.alert.whenTalkingToInstallersText}
        </Text>
      </Stack>
    </Alert>
  );
};
